// extracted by mini-css-extract-plugin
export default {"root":"LabelHelper_root__C4Jts","rootText":"LabelHelper_rootText__jRNcE","popover":"LabelHelper_popover__XRcsc"};